<template>

  <svg
    t="1639124363597"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3965"
    width="64"
    height="64"
  ><path d="M78.769231 157.53846199h866.461538v708.92307602H78.769231V157.53846199z m78.76923099 78.76923001v551.384616h708.92307602V236.307692H157.53846199z m433.23076901 39.384616h236.307692v472.615384H590.769231V275.692308z" p-id="3966" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconRpanel',
} as DefineComponent
</script>